import AdminPoliciesPage from '../../../components/admin/policies/AdminPoliciesPage'

export default function PolicyDocuments() {
  return <AdminPoliciesPage />
}
